/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Project_Saved_SuccessInputs */



/**
* | output |
* | --- |
* | "Project saved successfully" |
*
* @param {Project_Saved_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const project_saved_success = /** @type {((inputs?: Project_Saved_SuccessInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_Saved_SuccessInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Projet enregistré avec succès")
	if (locale === "de") return /** @type {LocalizedString} */ ("Projekt erfolgreich gespeichert")
	if (locale === "it") return /** @type {LocalizedString} */ ("Progetto salvato con successo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Проект успешно спасен")
	if (locale === "es") return /** @type {LocalizedString} */ ("Proyecto guardado exitosamente")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("项目已成功保存")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プロジェクトが正常に保存されました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रोजेक्ट सफलतापूर्वक सहेज लिया गया")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Projeto salvo com sucesso")
	return /** @type {LocalizedString} */ ("Project saved successfully")
});